
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class SalaryPackageDetailsDialog extends _Ext.EditorDialogBase<SalaryPackageDetailsRow> {
        protected getFormKey() { return SalaryPackageDetailsForm.formKey; }
        protected getIdProperty() { return SalaryPackageDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return SalaryPackageDetailsRow.localTextPrefix; }
        protected getNameProperty() { return SalaryPackageDetailsRow.nameProperty; } 

        protected form = new SalaryPackageDetailsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        constructor() {
            super();
            q.setTextRightAlign(this.form.Amount);
            q.setTextRightAlign(this.form.Percentage);
            this.form.Amount.changeSelect2(e => {
                this.form.Percentage.value = 0;
            });
            this.form.Percentage.changeSelect2(e => {
                this.form.Amount.value = 0;
            });
        }
    }
}